import { endpoints } from "@app/api/apis"
import handleApiErr from "@app/helper/handleApiErr"
import ROUTE from "@app/navigationApp/routes"
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet"
import Button from "@app/sharedComponents/Button/Button"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { useAppDispatch, useAppSelector } from "@app/store/hooks"
import { showErrorSheet } from "@app/store/slices/errorSlice"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility"
import { FORECLOSURE_HANDLING } from "@app/utils/utils"
import axios from "axios"
import { useState } from "react"
import { ScrollView,Image } from "react-native"
import { Info } from "@app/sharedComponents/Icons/Icons";
import dayjs from "dayjs"


const OldForeClosure = ({navigation}) =>{
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const creditInfo = useAppSelector((state) => state.auth.creditDetails);
    const loanData = useAppSelector(state => state.auth.loanDetails);
    const {loanDetails} = loanData;
    const [buttonLoader,setButtonLoader] = useState(false)
    const dispatch = useAppDispatch()
    const [bottomSheetData, setBottomSheetData] = useState(null);
    const [isBottomSheetVisible,setIsBottomSheetVisible] = useState(false)
    
    const openBottomSheet = (data:any) => {
        setBottomSheetData(data)
        setIsBottomSheetVisible(true);
    };

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };

    const onViewTransactions = ()=>{
        closeBottomSheet() 
        setTimeout(()=>{
            navigation.navigate(ROUTE.TRANSACTION_SCREEN)
        }
        ,500)
    }

    const continueForeclosure = () => {
        setButtonLoader(true)
        const url = endpoints.foreclosureValidationAndDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
           navigation.navigate(ROUTE.CONFIRM_LOAN_DETAILS,{isFromBajaj:true})
        }).catch((err)=>{
            if(handleApiErr(err)){
                const { voltErrorCode, message,statusCode,header } = err?.data;
                const transactionError = voltErrorCode === FORECLOSURE_HANDLING.UNLIEN_IN_PROCESS || voltErrorCode === FORECLOSURE_HANDLING.DISBURSAL_IN_PROCESS || voltErrorCode === FORECLOSURE_HANDLING.REPAYMENT_IN_PROCESS
                if(transactionError){
                    openBottomSheet(err?.data)
                } else{
                dispatch(showErrorSheet({
                    errorHeading:header,
                    isErrorSheetVisible : true,
                    errorMessage: message,
                    closeOnBackdropPress: true,
                    errorType:voltErrorCode || statusCode,
                    showMsgBg:true,
                    btnName: "Ok, got it!",
                }))
            }}
        }).finally(()=>{
            setButtonLoader(false)
        })
    }
    return(
        <>
            <PageHeaders label="Foreclose your loan" pageName="OldForclosure" navigation={navigation}/>
            <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-page"]}}>
                <ThemedView my="2xl" p="lg" alignItems="center" backgroundColor="bg-surface-primary">
                    <ThemedText color="text-secondary" variant="b3r">Your credit line</ThemedText>
                    <ThemedView
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1,
                        }}
                    >
                        <ThemedText variant="l1" color="text-emphasis-secondary">₹</ThemedText>
                        <ThemedText color="text-emphasis-secondary" variant="h1b">{formatIndianCurrency(creditInfo?.availableCreditAmount)}</ThemedText>
                    </ThemedView>
                    <ThemedText color="text-secondary" variant="b3r">is available for 
                        <ThemedText color="text-secondary" variant="b3s"> FREE</ThemedText>
                        <ThemedText color="text-secondary" variant="b3r"> till </ThemedText>
                        <ThemedText color="text-secondary" variant="b3s">{dayjs(loanDetails?.expiryDate).format('DD MMM, YYYY')}</ThemedText>
                    </ThemedText>
                    <ThemedView py="lg" px="xl" backgroundColor="bg-fill-secondary" borderRadius="lg" mt="lg" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <ThemedView alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_flash.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m" color="text-secondary" textAlign="center">Get instant cash</ThemedText>
                        </ThemedView>
                        <ThemedView height={'80%'} width={1} backgroundColor="border-secondary" mx="md"/>
                        <ThemedView  alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_percent.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m"  color="text-secondary" textAlign="center">Portfolio keeps growing</ThemedText>
                        </ThemedView>
                        <ThemedView height={'80%'} width={1} backgroundColor="border-secondary" mx="md"/>
                        <ThemedView  alignItems="center" flex={1} flexWrap="wrap">
                            <Image source={{uri : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/green_lock.png"}} style={{width:36, height : 36 }}/>
                            <ThemedText variant="b4m" color="text-secondary" textAlign="center">Investments are safe </ThemedText>
                        </ThemedView>

                    </ThemedView>
                </ThemedView>
                <ThemedView p="lg" backgroundColor="bg-surface-primary" >
                    <ThemedText variant="h5s" color="text-primary" mb="lg">Foreclose your loan anytime without any hidden charges</ThemedText>
                    <ThemedView position='relative'>
            <ThemedView flexDirection='row' mb="2xl">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >1</ThemedText>
                </ThemedView>
                <ThemedView ml="md"  flexWrap='wrap' flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">Raise a request for foreclosure anytime</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView position='absolute' left={15} top={15} zIndex={-1} height={75} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row' mb="2xl" position='relative' >
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >2</ThemedText>
                </ThemedView>
                <ThemedView ml="md"  flexWrap='wrap' flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">Make payments on existing dues</ThemedText>
                </ThemedView>
            </ThemedView>
            <>
            <ThemedView position='absolute' left={15} bottom={50} zIndex={-1} height={100} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row'  flexShrink={1} mr="md">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >3</ThemedText>
                </ThemedView>
                <ThemedView ml="md" flex={1}>
                    <ThemedText variant='b3m' color="text-secondary">We will approve the request to release collateral within 1-2 business days</ThemedText>
                </ThemedView>
            </ThemedView>
            </>
        </ThemedView>
                </ThemedView>
            </ScrollView>
            <ThemedView backgroundColor="bg-surface-primary" p="lg" >
                <Button label="Proceed to foreclose loan" handlePress={continueForeclosure} buttonLoader={buttonLoader}/>
            </ThemedView>
            <BottomSheetContainer
                isVisible={isBottomSheetVisible}
                close={closeBottomSheet}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                containerStyle={{ backgroundColor: '#fefefe' }}
                >
                <ThemedView alignItems='center' justifyContent='center' p="lg">
                    <ThemedView my="sm">
                        <Info size={60} weight="fill"  color="#f9bd21"/>
                    </ThemedView>
                     <ThemedText mt="lg" variant='h5s' color='text-primary'>{bottomSheetData?.header}</ThemedText>
                    <ThemedView mt="sm" mb="2xl" backgroundColor='bg-fill-info' p="sm" borderRadius='sm' width={'100%'}>
                        <ThemedText textAlign='center' color='text-secondary' variant='b4r'>
                        {bottomSheetData?.message}
                        </ThemedText>
                    </ThemedView>
                    <Button
                    label={'View transaction details'}
                    type='OUTLINED'
                    handlePress={onViewTransactions}
                    overRideStyle={{marginBottom: 12}}
                    />
                    <Button
                    label={'Ok, got it!'}
                    type={'SOLID'}
                    handlePress={closeBottomSheet}
                    />
                </ThemedView>
            </BottomSheetContainer>
        </>
    )
}

export default OldForeClosure